import React, { memo, useCallback, useEffect, useState } from 'react';
import { List } from 'antd';
import Dot from './dot';
import Header from './selectBox';
import colors from './colors';
import { Loading, NoData } from '@components';
import { filterData, getYearsCateOptions, getYearOptions } from './utils';

function HistoryList({
  dataSource = [],
  years = [],
  categories = {},
  yearsWithCateId = {},
  isLoading,
}) {
  const [filters, ChangeFilters] = useState({});
  const renderList = useCallback(
    (item) => (
      <li className="company-history-list-item">
        <div className="dot-wrapper">
          <Dot color={colors[item.category - 1]} tip={item.categoryLabel} />
        </div>
        <div className="text">{item.news}</div>
      </li>
    ),
    [],
  );

  const handleChangeFilter = (value = {}) => {
    const newFilters = { ...value };

    if (newFilters.year && newFilters.year !== filters.year) {
      newFilters.category = categories[newFilters.year];
    }

    ChangeFilters(newFilters);
  };

  useEffect(() => {
    const newFilters = {};
    if (years.length > 0) {
      newFilters.year = years[0];
    }

    if (categories[newFilters.year]?.length > 0) {
      newFilters.category = categories[newFilters.year];
    }

    if (Object.keys(newFilters).length > 0) {
      ChangeFilters(newFilters);
    }
  }, [years, categories]);

  if (isLoading) {
    return (
      <div className="stock-chart-wrapper">
        <Loading />
      </div>
    );
  }

  if (!dataSource?.length > 0) {
    return <NoData />;
  }

  return (
    <div className="company-history-list-wrapper">
      <List
        header={
          <Header
            onChange={handleChangeFilter}
            filters={filters}
            yearOptions={getYearOptions(years)}
            categoryOptions={getYearsCateOptions({
              years: [`${filters.year}`],
              categories,
              yearsWithCateId,
            })}
          />
        }
        dataSource={filterData(dataSource, filters)}
        renderItem={renderList}
      />
    </div>
  );
}

HistoryList.propTypes = {};

export default memo(HistoryList);
